import { render } from "./WDataTable.vue?vue&type=template&id=03e12ec7&ts=true"
import script from "./WDataTable.vue?vue&type=script&lang=ts"
export * from "./WDataTable.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__